import React, { useState } from "react"
import { Telemetry } from "../event-emitter"
import { ColorTile } from "./color-tile"

export type DesignColors = {
  colors: string[]
  handleColorSelect?: (color: string) => void
}

export type DesignColorsSectionProps = {
  /** Colors detected in the current design */
  colors?: string[]
  /** Called when a design color tile is clicked */
  handleColorSelect: (color: string) => void
}

export const MAX_DESIGN_COLORS = 12

/**
 * A section that displays the colors used in the current design. Clicking a
 * tile applies that color.
 */
export function DesignColorsSection({
  colors = [],
  handleColorSelect
}: DesignColorsSectionProps) {
  // Freeze the palette when the picker opens.
  const [frozenColors] = useState(colors)

  const tiles = frozenColors
    .slice(0, MAX_DESIGN_COLORS)
    .map((color, index) => (
      <ColorTile
        color={color}
        key={index}
        handleColorSelect={handleColorSelect}
      />
    ))

  return (
    <div className="border-t w-auto mt-4 -mx-3">
      <div className="pl-3 mr-3 w-auto">
        <div className="flex items-center justify-between mt-3 mb-2">
          <div className="text-gray-800 text-xs font-semibold">
            In this design
          </div>
        </div>
        <Telemetry value={{ name: "color_tile", source: "design_colors" }}>
          <div className="grid grid-cols-6 gap-2">{tiles}</div>
        </Telemetry>
      </div>
    </div>
  )
}
